import React,{ElementType, useContext} from 'react'
import styles from './styles.module.css'

import {InputBaseComponentProps } from '@material-ui/core' 

import OutlinedInput from '@material-ui/core/OutlinedInput';
import { ErrorOutline } from '@material-ui/icons'
import FormHelperText from '@material-ui/core/FormHelperText'
import { PLACEHOLDERS } from '@/utils/constants'
import { PhoneMaskCustom } from '@/components/molecules/PhoneMaskCustom'
import PhoneIcon from '@/public/images/icons/phone-icon.svg' 
import { DealerDetailsContext } from '@/context/dealerDetailsContext';
import EmailIcon from '@/public/images/icons/email-icon.svg'

function ModalDealerContactForm() {

    const {formState,register,setError} =useContext(DealerDetailsContext)
    const {errors}=formState 
 
    const validatePhoneNumber = (value) => {
        const strippedPhoneNumber = value.replace(/\D/g, ''); 
    
        if (strippedPhoneNumber.length !== 10) {
          setError('phone_number', {
            type: 'manual',
            message: 'Phone number must have 10 digits'
          });
          return 'Phone number must have 10 digits'; 
        }
    
        return true;
      };

    return ( 
        <div className={styles.dealerForm}>
        <h4 className={styles.headerSubtitle}>Dealer Contact information</h4> 

    <div className={styles.nameField}>
        <div className={styles.nameField1}>
            <OutlinedInput
                className='w-100'
                placeholder='First Name'
                id="first_name"
                type="text"
                name="first_name"
                endAdornment={errors.first_name ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}
                error={errors.first_name}
                {...register('first_name', {
                    required: {
                        value: true,
                        message: 'First Name is required',
                    },
                    validate: (value) => !!value.trim() || 'First Name is required' 
                })} />
            {errors.first_name && (
                <FormHelperText error={true} id="dealerform-error" className="input-helper-text">
                    {errors.first_name?.message}
                </FormHelperText>
            )}
        </div>
        <div className={styles.nameField2}>
            <OutlinedInput
                placeholder='Last Name'
                className='w-100'
                id="last_name"
                type="text"
                name="last_name"
                endAdornment={errors.last_name ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}
                error={errors.last_name}
                {...register('last_name', {
                    required: {
                        value: true,
                        message: 'Last Name is required',
                    },
                    validate: (value) => !!value.trim() || 'Last Name is required' 
                })} />
            {errors.last_name && (
                <FormHelperText error={true} id="dealerform-error" className="input-helper-text">
                    {errors.last_name?.message}
                </FormHelperText>
            )}
        </div>
    </div>
    <OutlinedInput
        fullWidth
        className='w-100'
        placeholder='Email Address'
        disabled
        id="emailId"
        type="text"
        name="emailId"
        endAdornment={errors.emailId ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}
        error={errors.emailId}
        {...register('emailId',
        {
            required: {
                value: true,
                message: 'Email Id is required',
            },
            validate: (value) => !!value.trim() || 'Email Id is required'
        }
        )} 
        startAdornment={<img src={EmailIcon.src} />} />
    {errors.emailId && (
        <FormHelperText error={true} id="dealerform-error" className="input-helper-text">
            {errors.emailId?.message}
        </FormHelperText>
    )}
    <div className={styles.nameField}>
        <div className={styles.phone_number}>
        <OutlinedInput 
            fullWidth
            className='w-100'
            id="phone_number"
            name="phone_number"
            placeholder={PLACEHOLDERS.phoneNumber}
            error={Boolean(errors?.phone_number)}
            inputComponent={PhoneMaskCustom as ElementType<InputBaseComponentProps>}
            startAdornment={<img src={PhoneIcon.src} alt=""/>}
            endAdornment={errors.phone_number ? <ErrorOutline style={{ color: '#f44336' }} /> : ''}
            {...register('phone_number', {
                required: {
                    value: true,
                    message: 'Phone Number is required',
                },
                validate:{
                    validateRequired: (value) => !!value.trim() || 'Phone Number is required' ,
                    validPhoneNumber: validatePhoneNumber
                }
            })} 
        />  
            {errors.phone_number && (
                <FormHelperText error={true} id="dealerform-error" className="input-helper-text">
                    {errors.phone_number?.message}
                </FormHelperText>
            )}
        </div>
        <div className={styles.phone_number1}></div>
    </div>
        </div> 
    )
}

export default ModalDealerContactForm
